import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const OverlayContext = createContext();

export const useOverlay = () => useContext(OverlayContext);

export const OverlayProvider = ({ children }) => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [overlayContent, setOverlayContent] = useState(null);
    const [overlayFooter, setOverlayFooter] = useState(null);
    const [overlayOpts, setOverlayOpts] = useState({});
    const location = useLocation();
    const locationKeyRef = useRef(`${location.pathname}|${location.search}|${location.hash}`);

    const showOverlay = useCallback((content, opts = {}) => {
        setOverlayContent(content);
        setOverlayFooter(opts.footer ?? null);
        setOverlayOpts({
            compact: !!opts.compact,
        });
        setIsOverlayOpen(true);
    }, []);

    const hideOverlay = useCallback(() => {
        setIsOverlayOpen(false);
        setTimeout(() => {
            setOverlayContent(null);
            setOverlayFooter(null);
            setOverlayOpts({});
        }, 300);
    }, []);

    // Auto-close overlay when route changes (pathname, search, or hash)
    useEffect(() => {
        const locationKey = `${location.pathname}|${location.search}|${location.hash}`;
        const locationChanged = locationKeyRef.current !== locationKey;
        locationKeyRef.current = locationKey;
        if (locationChanged && isOverlayOpen) {
            hideOverlay();
        }
    }, [location.pathname, location.search, location.hash, hideOverlay, isOverlayOpen]);

    const value = {
        isOverlayOpen,
        overlayContent,
        overlayFooter,
        overlayOpts,
        showOverlay,
        hideOverlay,
    };

    return (
        <OverlayContext.Provider value={value}>
            {children}
        </OverlayContext.Provider>
    );
};
